import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ChaptersSection() {
  const chapters = [{
    title: 'Ciclos de sueño del bebé',
    desc: 'Entenderás por qué el despertar a los 40–60 minutos es tan común y qué significa.'
  }, {
    title: 'Causas reales de los despertares nocturnos',
    desc: 'Aprenderás a identificar si es hambre real, asociación de sueño, sobrecansancio/poca presión de sueño, ambiente, regresión, o algo que conviene revisar con pediatra.'
  }, {
    title: 'Ventanas de sueño por edad + cómo aplicarlas',
    desc: 'Tablas claras, señales de sueño y cómo armar un horario flexible (sin estrés).'
  }, {
    title: 'Rutinas efectivas desde recién nacidos hasta 3 años',
    desc: 'Rutinas cortas y realistas, con ejemplos por etapa.'
  }, {
    title: 'Regresiones del sueño',
    desc: 'Qué son, cuándo aparecen y qué hacer para no perder lo avanzado.'
  }, {
    title: 'Estrategias para reducir despertares (paso a paso)',
    desc: 'Qué hacer en la madrugada, cómo responder sin empeorar el patrón y cómo avanzar de forma gradual.'
  }, {
    title: 'Ambiente ideal para dormir',
    desc: 'Lo esencial: oscuridad, temperatura, ruido blanco bien usado y seguridad del sueño.'
  }, {
    title: 'Errores comunes que impiden dormir bien',
    desc: 'Y cómo corregirlos sin culpa.'
  }];
  return <section className="py-12 md:py-20 px-4 md:px-6 bg-navy-light" data-id="element-48">
      <div className="max-w-5xl mx-auto" data-id="element-49">
        <FadeIn data-id="element-50">
          <div className="text-center mb-8 md:mb-16" data-id="element-51">
            <h2 className="text-2xl md:text-4xl font-serif mb-3 md:mb-4 text-gold" data-id="element-52">
              ¿Qué incluye el ebook?{' '}
              <span className="italic text-gold text-lg md:text-3xl" data-id="element-53">
                (en lenguaje simple)
              </span>
            </h2>
            <p className="text-base md:text-xl text-white/70" data-id="element-54">
              Dentro de la guía encontrarás:
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-55">
          {chapters.map((chapter, index) => <FadeIn key={index} delay={index * 0.08} direction="up" data-id="element-56">
              <div className="bg-navy-card rounded-2xl md:rounded-3xl p-5 md:p-8 shadow-md shadow-gold/5 border border-gold/10 h-full relative overflow-hidden group hover:border-gold/30 transition-colors duration-300" data-id="element-57">
                <div className="absolute -right-4 -top-8 text-7xl md:text-9xl font-serif font-bold text-navy-light opacity-30 select-none pointer-events-none group-hover:scale-110 transition-transform duration-500" data-id="element-58">
                  {index + 1}
                </div>

                <div className="relative z-10" data-id="element-59">
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gold text-navy flex items-center justify-center font-serif font-bold text-base md:text-xl mb-3 md:mb-6 shadow-sm" data-id="element-60">
                    {index + 1}
                  </div>
                  <h3 className="text-lg md:text-xl font-serif font-bold text-white mb-2 md:mb-3" data-id="element-61">
                    {chapter.title}
                  </h3>
                  <p className="text-sm md:text-base text-white/70 leading-relaxed" data-id="element-62">
                    {chapter.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}